<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-left fluid>
                <v-layout v-if="validPayment == true && !resourcePath.length" row wrap>
                    <v-flex xs12 md12 lg12 xl12>
                        <v-flex xs12 md3 lg3 xl3 class="text-xs-left">
                            <v-text-field v-model="merchantName" label="Merchant Name" readonly></v-text-field>
                            <v-text-field v-model="form.merchantTransactionId" label="Merchant Transaction ID" readonly></v-text-field>
                            <v-text-field v-model="form.firstName" label="First Name" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.surname" label="Surname" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.address1" label="Address 1" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.address2" label="Address 2"></v-text-field>
                            <v-text-field v-model="form.city" label="City" :rules="rules" required></v-text-field>
                            <v-text-field v-model="form.postcode" label="Postcode" :rules="rules" required></v-text-field>
                            <v-select v-model="form.country" :items="countryOptions" :rules="rules" label="Please select a country"></v-select>
                            <v-text-field v-model="form.email" label="Email address" readonly></v-text-field>
                            <v-text-field v-model="form.amount" label="Amount" readonly></v-text-field>
                            <v-text-field v-model="form.currency" label="Currency" readonly></v-text-field>
                            <v-btn class="ml-0" @click="onSubmit" color="primary mr-0">Pay Now</v-btn>
                        </v-flex>
                        <v-flex class="text-xs-left" xs12 md4 lg4 xl4 pl-0>
                            <v-flex xs12 mt-2>
                                <form :action="formAction" class="paymentWidgets" data-brands="VISA MASTER AMEX APPLEPAY"></form>
                            </v-flex>
                        </v-flex>
                    </v-flex>

                </v-layout>
                <v-layout v-else-if="validPayment == false && !resourcePath.length" row wrap>
                    <v-flex xs12>Invalid Payment ID</v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';

export default {
    data() {
        return {
            paymentId: this.$route.params.id,
            paymentData: [],
            channel: {},
            validPayment: null,
            merchantName: null,
            rules: [
                    v => !!v || 'Required field'
                ],
            form: {
                    merchantTransactionId: null,
                    firstName: null,
                    surname: null,
                    address1: null,
                    address2: null,
                    city: null,
                    postcode: null,
                    country: null,
                    email: null,
                    amount: null,
                    currency: null,
                    recurringType: 'NONE'
                },
            countryOptions: [
                    { value: 'AU', text: 'Australia' },
                    { value: 'CA', text: 'Canada' },
                    { value: 'CN', text: 'China' },
                    { value: 'FR', text: 'France' },
                    { value: 'DE', text: 'Germany' },
                    { value: 'IN', text: 'India' },
                    { value: 'JP', text: 'Japan' },
                    { value: 'SP', text: 'Spain' },
                    { value: 'GB', text: 'United Kingdom' },
                    { value: 'US', text: 'United States' }
                ],
            checkoutId: null,
            resourcePath: null,
            host: window.location.hostname
        }
    },
    mixins: [ sweetAlert ],
    beforeMount() {
        this.getPayment();
        this.getPaymentStatusPath();
        console.log(this.validPayment);
    },
    computed: {
        formAction() {
            if(this.host == 'localhost') {
                return `http://localhost:8080/pay-by-link-payment/${this.paymentId}`;
            }
            else {
                return `https://management.totalprocessing.com/pay-by-link-payment/${this.paymentId}`;
            }
        }
    },
    methods: {
        getPayment() {
            if(!this.resourcePath) {
                axios({
                method: 'post',
                data: { paymentId: this.paymentId },
                url: 'https://controlapi.totalprocessing.com/api/get-pay-by-link',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.paymentData = response.data[0];
                    this.validPayment = 'id' in this.paymentData ? true : false;

                    if(this.validPayment) {
                        this.merchantName = response.data[0].merchantName;
                        this.form.merchantTransactionId = response.data[0].merchantTransactionId;
                        this.form.email = response.data[0].email;
                        this.form.amount = response.data[0].amount;
                        this.form.currency = response.data[0].currency;

                        this.channel.url = 'oppwa.com';
                        this.channel.userId = response.data[0].channelLogin;
                        this.channel.password = response.data[0].channelPwd;
                        this.channel.entityId = response.data[0].channelUuid;
                    }

                    console.log(this.paymentData);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        onSubmit() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/process-request',
                data: { form: this.form, channel: this.channel, paymentType: 1, pbl: true },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const copyAndPayScript = document.createElement('script');
                    this.checkoutId = response.data.id;
                    console.log(response.data);

                    copyAndPayScript.setAttribute('src', 'https://oppwa.com/v1/paymentWidgets.js?checkoutId='+this.checkoutId);
                    document.head.appendChild(copyAndPayScript);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getPaymentStatusPath() {
            this.resourcePath = decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('resourcePath').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            this.getPaymentStatus();
        },
        getPaymentStatus() {
            if(this.resourcePath.includes('/v1/checkouts/')) {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-payment-status',
                data: { resourcePath: this.resourcePath, paymentId: this.paymentId },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.sweetAlert(response.data);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
    }
}
</script>

<style>
    .wpwl-form {
        margin: 0 !important;
    }
</style>